import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/hooks/useChatQueryKeys.ts
var t = (e) => {
	let t = {};
	for (let [n, r] of Object.entries(e)) r !== void 0 && (t[n] = r);
	return t;
}, n = e("chat", {
	conversations: (e) => e ? ["conversations", t(e)] : ["conversations"],
	conversation: (e) => ["conversation", e],
	messages: (e) => ["messages", e],
	inboxLookup: (e) => ["inboxLookup", e],
	byBooking: (e) => ["byBooking", e],
	messageRequests: () => ["messageRequests"],
	internalNotes: (e) => ["internalNotes", e],
	summary: (e) => ["summary", e],
	inboxAssignees: (e) => ["inboxAssignees", e],
	adminSupportUnread: () => ["adminSupportUnread"],
	adminSupportMessages: (e) => ["adminSupportMessages", e],
	adminSupportNotes: (e) => ["adminSupportNotes", e],
	adminSupportSummary: (e) => ["adminSupportSummary", e],
	adminSupportConversation: (e) => ["adminSupportConversation", e]
});
//#endregion
export { n as chatQueryKeys };
